import { action } from 'satcheljs';
import type { CommandingViewMode } from 'owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions';

export interface OnViewModeChangedActionMessage {
    viewMode: CommandingViewMode;
}
export const onViewModeChanged: (viewMode: CommandingViewMode) => OnViewModeChangedActionMessage =
    action(
        'onViewModeChanged',
        (viewMode: CommandingViewMode): OnViewModeChangedActionMessage => ({
            viewMode,
        })
    );
